import { Typography } from '@mui/material'
import React from 'react'
import Topbar from '../layouts/Topbar';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import totalschools_icon from '../../superadmin/assets/dashboard.png';

const Reports = () => {
    const navigate = useNavigate();
    return (
        <div>
            <Topbar />
            <section className='main-1'>
                <div className='employees-text'>
                    <Typography variant='h5'>Reports</Typography>
                    {/* <Button variant="outlined" onClick={handleAddClick}>Add School</Button> */}
                </div>
                <section className='dashboard-count'>
                    <Grid container spacing={5}>
                        <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
                            <div className='dashboard-box'>
                                <img src={totalschools_icon} alt='total_schools' width={'30px'} />
                                <Typography>Daily Transactions</Typography>
                                <Typography variant='h6'></Typography>
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
                            <div className='dashboard-box'>
                                <img src={totalschools_icon} alt='total_schools' width={'30px'} />
                                <Typography>Item Report</Typography>
                                <Typography variant='h6'></Typography>
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 3 }}>
                            <div className='dashboard-box' >
                                <img src={totalschools_icon} alt='total_schools' width={'30px'} />
                                <Typography>Monthly Transactions</Typography>
                                <Typography variant='h6'></Typography>
                            </div>
                        </Grid>
                    </Grid>
                </section>
            </section>
        </div>
    )
}

export default Reports